(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('upsell-recommendations')) {
    customElements.define('upsell-recommendations', class UpsellRecommendations extends HTMLElement {
      async connectedCallback() {
        const productId = this.dataset.productId;
        const limit = this.dataset.limit || 6;
        if (!productId) return;

        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations();
        }, { rootMargin: '0px 0px 200px 0px' });
        observer.observe(this);
      }

      async loadRecommendations() {
        const productId = this.dataset.productId;
        const limit = this.dataset.limit || 6;
        const sectionId = this.dataset.sectionId || 'cart-recommendations';
        const container = this.querySelector('[data-products-ajax]');
        const blockId = this.dataset.blockId;
        const titleEl = blockId ? document.getElementById('upsell-title-' + blockId) : null;
        if (!container) return;

        try {
          const base = window.routes && window.routes.product_recommendations_url;
          if (!base) return;
          const url = new URL(base, window.location.href);
          url.searchParams.set('section_id', sectionId);
          url.searchParams.set('product_id', productId);
          url.searchParams.set('limit', limit);
          const res = await fetch(url);
          const text = await res.text();
          const html = document.createElement('div');
          html.innerHTML = text;
          const cardsRoot = html.querySelector('.product-upsell-recommendations [data-upsell-products]');
          if (!cardsRoot || !cardsRoot.children.length) {
            container.innerHTML = '';
            if (titleEl) titleEl.setAttribute('hidden', '');
            return;
          }
          container.innerHTML = '';
          if (titleEl) titleEl.removeAttribute('hidden');
          while (cardsRoot.firstChild) {
            container.appendChild(cardsRoot.firstChild);
          }
        } catch (e) {
          container.innerHTML = '';
          if (titleEl) titleEl.setAttribute('hidden', '');
          console.warn(e);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
